


















































import Vue from 'vue'
import { setEndDate, setStartDate } from '../store/actions'
import { routerReplace } from '../helpers'
import { EventBus } from '../helpers/EventBus.vue'

interface DFData {
	pickerPlaceholder: string
}

interface DFMethods {
	toTop(): void
}

interface DFComputed {
	startDate?: string
	endDate?: string
}

export default Vue.extend<DFData, DFMethods, DFComputed, {}>({
	name: 'DateFilter',
	data() {
		return { pickerPlaceholder: 'åååå-mm-dd' }
	},
	computed: {
		startDate: {
			set(value) {
				this.$store.dispatch(setStartDate(value)).then(() => {
					routerReplace({
						query: this.$store.getters.getParams
					})
				})
			},
			get() {
				return this.$store.getters.date.start
			}
		},
		endDate: {
			set(value) {
				this.$store.dispatch(setEndDate(value)).then(() => {
					routerReplace({
						query: this.$store.getters.getParams
					})
				})
			},
			get() {
				return this.$store.getters.date.end
			}
		}
	},
	methods: {
		toTop() {
			//let filter close before scroll
			setTimeout(() => EventBus.$emit('scrollToTop'), 50)
		}
	}
})
